import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useCompanyProfileImageUpload = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onCompanyProfileImageUploadError = (err: AxiosError<ErrorHttpResponse>) => {
        const errorMessage = err?.response?.data?.message;

        // Handle case where message is an object (e.g., validation errors)
        let displayMessage = 'Something went wrong while uploading company profile image.';

        if (typeof errorMessage === 'string') {
            displayMessage = errorMessage;
        } else if (typeof errorMessage === 'object' && errorMessage !== null) {
            // Extract first error message from object
            const firstKey = Object.keys(errorMessage)[0];
            displayMessage = errorMessage[firstKey] || displayMessage;
        }

        toast.error(displayMessage);
    };

    const onCompanyProfileImageUploadSuccess = (resetFn: (...args: any) => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Company profile image uploaded successfully.');
        resetFn();
    };

    const uploadCompanyProfileImage = (data: any, resetFn: (...args: any) => void) => {
        const formData = new FormData();

        if (data.profilePicture instanceof File) {
            formData.append('profilePicture', data.profilePicture, data.profilePicture.name);
        } else {
            console.warn('No valid profilePicture provided');
        }

        const url: HttpConfig = {
            url: 'api/v1/company/update-details',
            method: 'patch',
            data: formData,
        };

        request(url, onCompanyProfileImageUploadSuccess(resetFn), setLoading, onCompanyProfileImageUploadError);
    };

    return { uploadCompanyProfileImage, loading };
};

export default useCompanyProfileImageUpload;
